<template>
    <div>
        <template v-if="view_attendance_correction">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Attendance Correction</h1>
                <button v-if="view_attendance_correction == true" class="btn btn-primary float-right processBillBtn" disabled @click="applyCorrection('APPROVED')"> Approve </button>
                <button v-if="view_attendance_correction == true" class="btn btn-primary float-right processBillBtn mr-2" disabled @click="applyCorrection('REJECT')"> Reject </button>
            </div>
            <div class="table">
                <table id="correctionTable" class="table" width="100%">
                    <thead>
                        <tr>
                            <th style="display: none;"></th>
                            <th>Applicant Name</th>
                            <!-- <th>Team Manager</th> -->
                            <th>Date</th>
                            <th>Time In</th>
                            <th>Time Out</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </template>
        <template v-else-if="view_attendance_correction == null">
            <preLoader></preLoader>
        </template>
        <template v-if="view_attendance_correction == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                view_attendance_correction:null,
                list_ids : [],
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('view_attendance_correction').then(result => {
                this.view_attendance_correction = result.view_attendance_correction;
            }).then(result => {
                if(this.view_attendance_correction == true){
                    this.listAttendanceCorrection();
                }
            });
        },
        methods: {
            applyCorrection(type){
                var that =this;
                // console.log(type, this.list_ids);
                this.$Progress.start();
                axios.post('/api/bulkAttendanceCorrectionHistoryUpdate',{'ids':this.list_ids, 'type':type}).then(res => {
                    if(res.status == 200){
                        that.$Progress.finish();
                        this.showToastBox('success','Attendance correction has been updated');
                        // this.$router.push('/listAttendanceCorrection');
                        location.reload();
                    }else{
                        that.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    }
                }).catch(err => {
                    that.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            generateButton: function(e){
                var id = e.target.value;
                if(gThat.list_ids.includes(id) == true){
                    gThat.list_ids.splice( $.inArray(id,gThat.list_ids), 1);
                }else{
                    gThat.list_ids.push(id);
                }

                var checkFlag = false;
                $('input.processBill').each(function(){
                    if($(this).is(':checked')){
                        checkFlag = true;
                    }
                });
                if(checkFlag == true){
                    $('.processBillBtn').removeAttr('disabled');

                }else{
                    $('.processBillBtn').attr('disabled','true');
                }
            },
            listAttendanceCorrection: function(){
                var that = this;
                var showBox = that.view_attendance_correction;
                $('#correctionTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom: '<"row pb-3 view-filter"<"col-md-12 pr-4 pl-4 text-right"f>><"table-holder mb-3"t><"row mb-3 view-pager"<"col-sm-4 pl-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 pr-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listAttendanceCorrection",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        // {data:'name', render: function(data,type,full){
                        //     if(full.user){ return full.user.name; }
                        //     else{ return '------------'; }
                        // } },
                        // {data:'line_manager', render: function(data,type,full){
                        //     if(full.line_manager){ return full.line_manager.name; }
                        //     else{ return '------------'; }
                        // } },
                        {"name":"name","mData": "name",
                            "mRender": function (data, type, full) {
                                var id = full['id'];
                                var name = '';
                                if(full.user){ name = full.user.name; }
                                else{ name = '------------'; }

                                var to_return ='';
                                if(showBox == true){
                                    to_return += '<label class="check-holder">\n' +
                                        '<input name="bill_ids[]" class="processBill" value="'+id+'" type="checkbox" onclick="VueComponents.listAttendanceCorrectionComponent.methods.generateButton(event)">\n' +
                                        '<span class="checkmark"></span>\n' +
                                        '</label>';
                                }
                                to_return += name;
                                return to_return;
                            }
                        },
                        {data: 'created_at'},
                        {data: 'time_in', render: function(data,type,full){
                            if(full.time_in){
                                var time_in = full.time_in;
                                var formatTime = moment(time_in, 'hh:mm:ss');
                                return formatTime.format('hh:mm a');
                            }
                        }},
                        {data: 'time_out', render: function(data,type,full){
                            if(full.time_out){ 
                                var time_out = full.time_out;
                                var formatTime = moment(time_out, 'hh:mm:ss');
                                return formatTime.format('hh:mm a');
                            }
                        }},
                        {data: 'status', render: function(data,type,full){
                          var updated_status='';
                        switch(full.status){
                            case 'WAITING':updated_status = 'Pending';break;
                            case 'APPROVED_TL':updated_status = 'Approved Team Lead';break;
                            case 'REJECTED_TL':updated_status = 'Reject Team Lead';break;
                            case 'APPROVED_HR':updated_status = 'Approved HR';break;
                            case 'REJECTED_HR':updated_status = 'Reject HR';break;
                        }
                        return updated_status;
                        }
                        },
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/viewAttendanceCorrection/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="View" class="action view"><i class="fas fa-eye"></i></a>';
                        }, visible: that.view_attendance_correction},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            }
        },
        created() {
        }
    }
</script>
